const fadeAnimation = {
    initial: {
        y: 24,
        opacity: 0,
    },
    whileInView: {
        y: 0,
        opacity: 1,
    },
    viewport: {
        once: true,
    },
    transition: {
        type: "tween",
        duration: 0.3,
        delay: 0.15,
    },
};

export default fadeAnimation;